import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/.pnpm/sonner@2.0.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ComponentErrorBoundary"] */ "/vercel/path0/src/components/error/ComponentErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/src/components/error/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Footer2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceProvider"] */ "/vercel/path0/src/core/application/providers/ServiceProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StateMachineProvider"] */ "/vercel/path0/src/core/application/providers/StateMachineProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/global.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/extra.css");
